// Counts voice calls started in this page load, whatever the surface (tutor, feedback, checkpoint, mastery,
// clinical station). A surface that must not open over a live call (the tutor name poll after a hang-up)
// remembers the count when it is offered and opens only if no call has started since. Framework-free and
// tiny: startup code may import it.
let voiceCallStartCount = 0;

export function noteVoiceCallStarting(): void {
  voiceCallStartCount += 1;
}

export function getVoiceCallStartCount(): number {
  return voiceCallStartCount;
}
